import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search, MoreVertical, Phone } from 'lucide-react';
import { Contact } from '../../types/chat';

interface ChatHeaderProps {
  contact: Contact | null;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ contact }) => {
  const { t } = useTranslation();
  if (!contact) {
    return (
      <div className="h-16 bg-gray-50 border-b border-gray-200 flex items-center justify-center">
        <p className="text-gray-500">{t('selectContactToStartChatting')}</p>
      </div>
    );
  }

  return (
    <div className="h-16 bg-gray-50 border-b border-gray-200 flex items-center px-4">
      {/* Contact Info */}
      <div className="flex items-center flex-1">
        <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center mr-3">
          <span className="text-white font-medium text-sm">{contact.avatar}</span>
        </div>
        <div>
          <h2 className="font-medium text-gray-900">{contact.name}</h2>
          <div className="flex items-center text-sm text-gray-600">
            <Phone className="w-3 h-3 mr-1" />
            <span>{contact.phoneNumber}</span>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="flex items-center space-x-4">
        <button className="p-2 hover:bg-gray-200 rounded-full transition-colors">
          <Search className="w-5 h-5 text-gray-600" />
        </button>
        <button className="p-2 hover:bg-gray-200 rounded-full transition-colors">
          <MoreVertical className="w-5 h-5 text-gray-600" />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;